import React from "react";
import { useTranslation } from "react-i18next";

const BorderSection = () => {
  const { t } = useTranslation();
  return (
    <section className="section-border wow fadeInUp">
      <div className="container">
        <div className="row">
          <div className="col">
            <article className="border-block">
              <div className="border-block_in">
                <div className="border-block_content">
                  <h3>{t("configuratorBlocksTitle1")}</h3>
                  <div className="row">
                    <div className="col-md-6">
                      {t("crmBlocksDesc11")}
                      <br />
                      {t("crmBlocksDesc12")}
                    </div>
                    <div className="col-md-6">{t("crmBlocksDesc13")}</div>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};
export default BorderSection;
